import dayjs from "dayjs";
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
dayjs.extend(quarterOfYear);

export const formatDate = (date, format = 'MM-DD-YYYY')  => {
    return dayjs(date).format(format);
}
export class DateHelper {

    _date=dayjs();

    constructor(date) {
        this._date = date ? dayjs(date) : dayjs();
    }

    date(_Date){
      return dayjs(_Date);
    }

    add(num, to_add) {
      return this._date.add(num, to_add);   
            
    }
    subtract(num, to_sub) {
      return this._date.subtract(num, to_sub);
  
    }
    startOf(unit_of_time = "month") {
      return this._date.startOf(unit_of_time);
     
    }

    endOf(unit_of_time = "month") {
      return this._date.endOf(unit_of_time);    
    }

    format(_format='MM-DD-YYYY') {
      return this._date.format(_format);  
    }

    diff(_Date,unit_of_time = "month") {
      return this._date.diff(_Date,unit_of_time);  
    }

    isSame(_Date,unit_of_time = "month") {
      return this._date.isSame(_Date,unit_of_time);  
    }

    unix(unit_of_time) {
      return this._date.unix(unit_of_time);  
    }
}



